import type { AccountWarningType } from "@/types/accountApiDef"
import { defineStore } from "pinia"
import { ref } from 'vue'

export const useLegacyVuexPersistedStore = defineStore('legacyVuexPersisted', () => {

  // アカウント毎の、閉じたバナー警告を記録する
  type ClosedAccountWarnings = {
    closedAccountWarnings_v1: {
      [accountId: string]: Array<{
        warning_type: AccountWarningType,
        service_contract_expired_at: number | null,
      }>
    }
  }
  const accountWarnings = ref<ClosedAccountWarnings>({ closedAccountWarnings_v1: {} })

  //  アカウント毎の、写真／黒板の検索履歴
  type SearchHistoryMap = {
    searchHistoryMap_v1: {
      [accountId: string]: {
        photo? : Array<string>,
        kokuban? :Array<string>,
      }
    }
  }
  const page = ref<SearchHistoryMap>({ searchHistoryMap_v1: {} })

  // アカウント毎の、最後のお知らせした日付
  type LastNotifiedDates = {
    lastNotifiedDates_v1: {
      [accountId: string]: string
    }
  }
  const premiumExpiringNotifications = ref<LastNotifiedDates>({ lastNotifiedDates_v1: {} })

  return {
    accountWarnings,
    page,
    premiumExpiringNotifications,
  }
},
{
  persist: {
    key: 'KuraemonCloud2',
    storage: localStorage,
    paths: [
      'accountWarnings.closedAccountWarnings_v1',
      'page.searchHistoryMap_v1',
      'premiumExpiringNotifications.lastNotifiedDates_v1',
    ],
  }
})